import { css } from 'styled-components';
import { media, rem } from '../../../helpers/mixins';
import { PURPLE, PINK, WHITE, GRAY } from '../../../constants/colors';

export default {


  input: ({icon}) =>  css`
    border: none;
    box-shadow: none;
    border-radius: 0;
    background-color: transparent;
    background-image: none;
    appearance: none;
    outline: none;
    &::-webkit-calendar-picker-indicator {
      background-image: url(${icon});
    }
   `,
  grayContainer: css`
    background-color: #d8d8d8;
    padding: 1% 5%;
    border-radius: 15px;
    margin-bottom: 20px;
 `,
  cartSection: () => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: center;
  `,

  container: css`
    margin-bottom: 20px;
    border-radius: 10px;
    border-style: solid;
    border-color: gray;
    padding: 20px 10px;
  `,

  column: css`
    ${media.md`
      flex-direction: column;
    `};
    ${media.mn1`
      margin:auto;
  `};
  `,

  startPointElement: () => css`
    background-color: #3F2A55;
    color: #FFFFFF;
    border-radius: 0.25rem;
    padding: 5px 40px;
    width:auto;
    height: 38px;
    margin:4px;  
    align-items: center;
    ${media.mn1`
      width: auto;
      margin: 5px;
      display: flex;
  `};
  `,

  notInclude: () => css`
    background-color: rgb(144, 120, 181);
    color: #FFFFFF;
    border-radius: 5px;
    padding: 3px;
    width: auto;
    margin: 0;
    
  `,

  row: css`
    grid-template-columns: repeat(3, minmax(10px, 1fr));
    ${media.sm`
      display: flex;
      flex-wrap:wrap;
      width: 100%;
      flex-direction: row;
      justify-content: space-around;
      margin: auto;
    `};
    ${media.mn1`
      display: flex;
    flex-wrap: wrap;
    `};
  `,

  routeContainer: css`
    ${media.sm`
    `};
    ${media.mn1`
      display: flex;
      grid-template-rows: repeat(3, minmax(100px, 1fr));
      flex-wrap: wrap;
    `};
  `,

  routeImg: css`
    margin-inline: 10px;
    cursor: pointer;
    background-color: #D8D8D8;
    padding: 5px 3px;
    border-radius: 32px;
    margin-bottom: 2px;
    ${media.sm`
    `};
    ${media.mn1`
      margin-inline: 1px;
      
    `};
  `,

  inputContainer: css`
    margin: 0px 30px 15px 0px;
  `,

  pinkBannerText: () => css`
    font-size: 18px;
    color: #FF3094;
    margin-bottom: 0;
  `,

  checkboxRound: () => css`
    width: 1.3em;
    height: 1.3em;
    background-color: white;
    border-radius: 50%;
    vertical-align: middle;
    border: 1px solid #ddd;
    appearance: none;
    -webkit-appearance: none;
    outline: none;
    cursor: pointer;
  `,

  checkboxRound: (checked) => css`
    background-color: gray;
  `,

  pinkText: () => css`
    font-size: 20px;
    color: #FF3094;
    margin-bottom: 0;
  `,

  buttonContainer: css`
    justify-content: flex-end;
    display: flex;
  `,

  labelPage: () => css`
    font-size: 25px;
    color: #3F2A55;
    padding-top: 9px;
    padding-left:10px;
    padding-right:10px;
  `,

  purplePrice: ({
    isTotal, maxWidth, textAlign, isSavingMoney
  }) => css`
    font-size: 40px;
    color: ;
    text-align: ${textAlign || 'left'};
  `,

  purpleUsd: ({
    isTotal, maxWidth, textAlign, isSavingMoney
  }) => css`
    font-size: 30px;
    color: #3F2A55;
    text-align: ${textAlign || 'left'};
    padding-top: 9px;
    padding-left:10px;
    padding-right:10px;
  `,


  line: css`
    background: #FF3094;
    height: 1.5px;
    width: 50px;
    margin: 0;
    padding: 0px;
    margin-top: 16.5px;
    ${media.sm`
      width: 120px;
    `}
    ${media.md`
      width: 170px;
    `}
  `,

  contain: css`
    display: flex;
    flex: 1;
    align-items: flex-start;
    justify-content: center;
    margin-top: -10px;

    ${media.sm`
      // margin-bottom: 1rem;
    `}
    ${media.md`
      width: 100%;
    `};
  `,

  circle: css`
    width: 30px;
    height: 30px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color:#FF3094;
    ${media.mn1`
      width: 5px;
      margin-top: 15px;
      height: 5px;
      margin-top: 15px;
      border-radius: 100%;
      background-color:#FF3094;
    `};
  `,


  inputRounderSelect: css`
    color: white;
    background-color:  #3F2A55;
    font-weight: bold;
    border: none;
    margin-left: 20px;
  `,

  modalWrapper: css`
   position: fixed;
   justify-content: center;
   display: flex;
   box-sizing: border-box;
   align-items: flex-start;
   bottom: 0px;
   left: 0px;
   right: 0px;
   top: 0px;
   z-index:2000;
   // background-color: rgba(67, 90, 111, 0.7);
   width: 100%;
   height: 100%;
 `,
  modalEntered: css`
    animation: 240ms cubic-bezier(0, 0, 0.2, 1) 0s 1 normal both running
    fadeInAnimation_1ont4t;
 `,
  dialog: css`
   background-color:${WHITE};
   box-shadow: rgba(67, 90, 111, 0.3) 0px 0px 1px,
     rgba(67, 90, 111, 0.47) 0px 16px 24px -8px;
   margin: 100px auto 0;
   transition: all 0.8s;
   width: 100%;
   max-width:540px;
   flex-direction: column;
   margin-top: 20%;
   margin-right: 16px;
   margin-left: 16px;
   border-radius: 8px;
   height:auto;
 `,
  header: ({ border }) => css`
   box-sizing: border-box;
   align-items: center;
   -webkit-box-align: center;
   -webkit-box-direction: normal;
   line-height: 1;
   padding: 25px 20px 10px 20px;
   flex-shrink: 0;
   display: flex;
   align-items: center;
 `,
  title: css`
   flex: 1 1 0%;
   line-height: 24px;
   margin-bottom: 0px;
   font-weight: 500;
   color:${PURPLE};
   text-align:center;
 `,
  body: css`
   padding-left: 16px;
   padding-right: 16px;
   padding-top: 6px;
   padding-bottom: 16px;
 `,
  footer: css`
   display: flex;
   clear: both;
   content: '';
   padding: 10px 20px 25px 20px;
   justify-content: center;
 `,
  primary: css`
   font-weight: bold;
 `,


};
